import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { JobDto } from 'app/models/dtos/job.dto';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-settings-jobs',
    templateUrl: './settings-jobs.component.html',
    // styleUrls: ['./settings-jobs.component.scss']
})
export class SettingsJobsComponent implements OnInit {
    constructor(private http: HttpClient, private titleService: Title) {}

    ngOnInit() {
        this.titleService.setTitle('Settings');
        this.loadJobs();
    }

    jobs: JobDto[] = [];
    jobsLoading = false;

    loadJobs(): void {
        this.jobsLoading = true;
        this.http
            .get<JobDto[]>(`${environment.services_tdusa_admin}/v1/jobs`)
            .subscribe({
                next: (jobs) => {
                    this.jobs = jobs;
                    this.jobsLoading = false;
                },
                error: () => {
                    this.jobsLoading = false;
                    console.error('Failed to load jobs.');
                },
            });
    }

    refreshJobs(): void {
        this.loadJobs();
    }
}
